import { useCallback, useMemo } from 'react';
import { getFunctionPerms } from '../api';
import { useDispatch, useSelector } from '../../../react-redux';
import { setFunctions } from '../../../reducers/function';

function useFunctionInit() {
  const dispatch = useDispatch();
  const state = useSelector(state => state.get('func'));
  const { functionMap, permReady, permMap, functions, perms } = useMemo(() => {
    return {
      functionMap: state.get('functionMap'),
      permMap: state.get('permMap'),
      permReady: state.get('permReady'),
      functions: state.get('functions'),
      perms: state.get('perms')
    };
  }, [state]);

  const initFunction = useCallback(() => {
    getFunctionPerms().then(res => {
      dispatch(setFunctions(res));
    });
  }, []);

  return { initFunction, functionMap, permReady, permMap, functions, perms };
}

export default useFunctionInit;
